import cx from 'clsx';
import type { ImageProps } from 'next/legacy/image';

import type { ProductStatus } from '~/api/model';
import { ResizeNextImage } from '~/app/common/components/ResizeNextImage';
import IconAdult19 from '~/assets/icons/ic_adult_19.svg';

import { ProductDisabledImageOverlay } from '~/app/common/components/Product/ProductDisabledImageOverlay';

export type StatusType = ProductStatus;

type Props = {
  src: string;
  alt?: string;
  type?: 'list' | 'grid';
  isOutOfStock?: boolean;
  rightBottom?: React.ReactNode;
  status?: StatusType;
  inverse?: boolean;
  className?: string;
  imageWrapperClassName?: string;
  leftTop?: React.ReactNode;
  /** 성인전용(19금) 상품 && 비성인 뷰어일 때 true → 썸네일 19 배지 오버레이 */
  showAdultBadge?: boolean;
  /** 19 배지를 우상단에 표시(작은 list형 썸네일용). 기본은 우하단(장바구니 버튼 위) */
  adultBadgeTopRight?: boolean;
} & ImageProps;

export function ProductImage({
  src,
  alt,
  isOutOfStock,
  rightBottom,
  type = 'grid',
  status,
  inverse,
  className,
  imageWrapperClassName,
  leftTop,
  showAdultBadge,
  adultBadgeTopRight = false,
  ...props
}: Props) {
  return (
    <div
      className={cx([
        'relative overflow-hidden rounded-16 border border-02 bg-screen-01 mb-8',
        inverse && 'after:bg-gray-000 [&>div]:z-10',
        className,
      ])}
    >
      <div className={cx('aspect-w-1 aspect-h-1', imageWrapperClassName)}>
        <div>
          <ResizeNextImage {...props} src={src} alt={alt} objectFit="contain" />
        </div>
      </div>
      <ProductDisabledImageOverlay
        type={type}
        status={status}
        isOutOfStock={isOutOfStock}
      />
      {showAdultBadge && (
        <>
          {/* 성인전용: 이미지 전체에 회색 반투명 veil(배지·버튼은 위에 있어 선명) */}
          <div className="pointer-events-none absolute inset-0 bg-[#6b7280]/40" />
          <div
            className={cx(
              'absolute',
              adultBadgeTopRight ? 'right-6 top-6' : 'bottom-[40px] right-8',
            )}
          >
            <IconAdult19 className="size-32" />
          </div>
        </>
      )}
      {leftTop && <div className="absolute left-0 top-0">{leftTop}</div>}
      {rightBottom && (
        <div className="absolute bottom-0 right-0">{rightBottom}</div>
      )}
    </div>
  );
}
